<ng-container *transloco="let t;">
    <div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
        <!-- Navbar brand -->
        <ul class="nav navbar-nav flex-row">
            <li class="nav-item">
                <a class="navbar-brand" [routerLink]="['/']">
                    <span class="brand-logo">
                        <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
                    </span>
                    <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
                </a>
            </li>
        </ul>
        <!--/ Navbar brand -->
    </div>

    <div class="navbar-container content">
        <div class="bookmark-wrapper simpleSignMainNavbar">
            <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
            <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
                <li class="nav-item">
                    <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
                        <span [data-feather]="'menu'" [class]="'ficon'"></span>
                    </a>
                </li>
            </ul>
            <!--/ Menu Toggler -->

            <!-- Toggle skin -->
            <ul class="navbar-nav nav simplesignMainMenu">
                <li ngbDropdown class="nav-item d-lg-block">
                    <a ngbDropdownToggle type="button" aria-haspopup="true" aria-expanded="false" id="sendDropdown"
                        class="nav-link nav-link-style btn d-flex align-items-center px-1 dropdown-toggle"
                        data-toggle="dropdown">
                    
                        <span class="fw-normal">{{t("Create new label (Navbar section) - Create new")}}</span>
                    </a>
                    <div ngbDropdownMenu class="dropdown-menu-right dropdown-menu sendDropdown-menu"
                        aria-labelledby="sendDropdown">
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" (click)="openSelectTemplate()">
                            <i class="menu-icon icon-template"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Use Template label (Navbar section) - Use Template")}}
                                <small class="mt-25 fw-normal">{{t("Use template sub title (Navbar section) - Start from a ready-made template for signing or internal use")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" (click)="uploadFileInput.click()"
                            *ngIf="canUploadDocument$ | async">
                            <i class="menu-icon icon-sign"></i>
                            <input class="hidden" #uploadFileInput type="file" multiple (change)="onFileDropped($event)"
                                [accept]="acceptableFiles" />
                            <span class="fw-bold p-1 border-start">
                                {{t("Upload for Signing label (Navbar section) - Upload for Signing")}}
                                <small class="mt-25 fw-normal">{{t("Upload an existing file sub title (Navbar section) - Upload an existing file to send for signature")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" (click)="documentUploadFileModalClick()"
                            *ngIf="canUploadDocumentsForArchive$ | async">
                            <i class="menu-icon icon-upload-archive"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Upload for Archive label (Navbar section) - Upload for Archive")}}
                                <small class="mt-25 fw-normal">{{t("Upload for Archive sub title (Navbar section) - Upload a document for record-keeping only")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" (click)="generateDocument()">
                            <i class="menu-icon icon-ai"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Al-Generated Document label (Navbar section) - Al-Generated Document")}}
                                <small class="mt-25 fw-normal">{{t("Let Al create sub title (Navbar section) - Let Al create a new document for signing or internal use")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" (click)="addContractModalModalClick()"
                            *ngIf="canUploadDocument$ | async">
                            <i class="menu-icon icon-c-contract-card"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Create Contract Card label (Navbar section) - Create Contract Card")}}
                                <small class="mt-25 fw-normal">{{t("Create Contract Card sub title (Navbar section) - Monitor contracts and insights in a card view")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item align-items-center py-0" (click)="createNewDocument()"
                            *ngIf="canUploadDocument$ | async">
                            <i class="menu-icon icon-blank"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Blank Document label (Navbar section) - Blank Document")}}
                                <small class="mt-25 fw-normal">{{t("Blank Document sub title (Navbar section) - Start from scratch for signing or internal use")}}</small>
                            </span>
                        </a>
                    </div>
                </li>


                <li ngbDropdown class="nav-item d-lg-block">
                    <a ngbDropdownToggle type="button" id="documentDropdown" aria-haspopup="true" aria-expanded="false"
                        class="nav-link nav-link-style btn d-flex align-items-center px-1 dropdown-toggle"
                        data-toggle="dropdown">
                    
                        <span class="fw-normal">{{t("Document Center label (Navbar section) - Document Center")}}</span>
                    </a>
                    <div ngbDropdownMenu class="dropdown-menu-right dropdown-menu sendDropdown-menu"
                        aria-labelledby="documentDropdown">
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" [routerLink]="['/documents']" [routerLinkActive]="['active-nav']">
                            <i class="menu-icon icon-documents"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Documents label (Navbar section) - Documents")}}
                                <small class="mt-25 fw-normal">{{t("Documents sub title (Navbar section) - View and manage all documents and signature requests")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem class="sort-asc menu-item border-bottom align-items-center py-0" [routerLinkActive]="['active-nav']" [routerLink]="['./contract-control']" *ngIf="('CC' | addonPermission | async)">
                            <i class="menu-icon icon-contract-cards"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Contract Cards label (Navbar section) - Contract Cards")}}
                                <small class="mt-25 fw-normal">{{t("Contract Cards sub title (Navbar section) - Organize and track contracts in an easy, card-based view")}}</small>
                            </span>
                        </a>
                        <a ngbDropdownItem placement="auto" triggers="hover" [ngbTooltip]="t('Image gallery modal tab item tooltip text - (Template/Document - section) - Coming soon')" class="sort-asc menu-item align-items-center py-0">
                            <i class="menu-icon icon-hubs"></i>
                            <span class="fw-bold p-1 border-start">
                                {{t("Document Hub label (Navbar section) - Document Hub")}}
                                <small class="mt-25 fw-normal">{{t("Document Hub sub title (Navbar section) - Group related documents together by topic or purpose")}}</small>
                            </span>
                        </a>
                    </div>
                </li>
            </ul>
            <!--/ Toggle skin -->
        </div>

        <ul class="nav navbar-nav align-items-center d-flex justify-content-end">
            <li class="remaining-days-bar" *ngIf="remainingDays !== 0">
                <p *ngIf="remainingDays === 1" class="nav-item mb-0"> {{remainingDays}} {{t('Trial periord remaining one
                    day text (navbar) Day Left')}}</p>
                <p *ngIf="remainingDays !== 1" class="nav-item mb-0"> {{remainingDays}} {{t('Trial periord remaining
                    days text (navbar) Days Left')}}</p>
                <a type="button" class="nav-link nav-link-style align-items-center px-1"
                    href="https://simplesign.io/contact-sales?utm_source=Platform&utm_medium=Trial&utm_campaign=Contact_Us"
                    target="_blank">
                    <i class="feather font-medium-5 d-xl-none d-block icon-phone"></i>
                    <button class="btn btn-primary d-xl-block d-none btn-sm">{{t('Contact us (navbar)Contact us')}}</button>
                </a>
            </li>
            <!-- ? Language selection | Uncomment if needed-->
            <li ngbDropdown class="nav-item dropdown dropdown-language">
                <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
                    <i class="{{ transloco.getActiveLang() | getNationFlag}}"></i><span class="selected-language">{{
                        t('language navbar list (navbar) - '+languageKeyDictionary[transloco.getActiveLang()])
                        }}</span>
                </a>
                <div ngbDropdownMenu aria-labelledby="dropdown-flag">
                    <a *ngFor="let lang of getAvailableLangs()" ngbDropdownItem (click)="setLanguage(lang)">
                        <i class="{{ lang | getNationFlag }}"></i> {{ t('language navbar list (navbar) -
                        '+languageKeyDictionary[lang]) }}
                    </a>
                </div>
            </li>
            <!--/ Language selection -->

            <!-- Toggle skin -->
            <li class="nav-item d-none d-lg-block">
                <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
                    <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
                        class="ficon font-medium-5 feather"></span>
                </a>
            </li>
            <!--/ Toggle skin -->

            <!-- User Dropdown -->
            <li ngbDropdown class="nav-item dropdown-user">
                <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle
                    id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
                    <span>
                        <app-user-avatar *ngIf="(userAvatarRefresher$ | async) === true" class="user-avatar"
                            cssVariant="bg-light-primary avatar-md" [userId]="(userSettings$ | async)?.id"
                            [shortcutName]="(userSettings$ | async)?.name | shortName"></app-user-avatar>
                    </span>
                </a>
                <div ngbDropdownMenu aria-labelledby="navbarUserDropdown"
                    class="dropdown-menu profileDropdownUL dropdown-menu-right" id="dropdown-menu-right">
                    <a ngbDropdownItem [routerLink]="['/profile-settings']"><span [data-feather]="'user'"
                            [class]="'me-50'"></span> {{t("Dropdown menu text (general) - Profile")}}</a>

                    <div class="dropdown-divider"></div>

                    <div class="form-group px-1 mb-50 workspace-dropdown">
                        <!-- <label class="col-form-label pt-0" for="name">{{t("Dropdown menu text (Navbar section) - Workspace")}}</label> -->
                        <div class="d-flex justify-content-start align-items-center columngap">
                            <span class="ms-25">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon icon-tabler icon-tabler-device-desktop-analytics" width="18" height="18"
                                    viewBox="0 0 24 24" stroke-width="1.5" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path
                                        d="M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z" />
                                    <path d="M7 20h10" />
                                    <path d="M9 16v4" />
                                    <path d="M15 16v4" />
                                    <path d="M9 12v-4" />
                                    <path d="M12 12v-1" />
                                    <path d="M15 12v-2" />
                                    <path d="M12 12v-1" />
                                </svg>
                            </span>
                            <ng-select 
                                [items]="(userSettings$ | async)?.workspaces" 
                                bindValue="id"
                                class="workspace-select d-flex" [clearable]="false" bindLabel="name"
                                [ngModel]="(activeWorkspace$ | async)?.id" [searchable]="false"
                                (change)="switchWorkspace($event.id)">
                                <ng-template ng-header-tmp *ngIf="(userSettings$ | async)?.tenant_owner">
                                    <span class="add-docTypebtn" (click)="openWorkSpaceModal()"><i data-feather="plus"
                                            [size]="16" class="cursor-pointer"></i> {{t("Dropdown menu text (Navbar section) - Add Workspace")}}</span>
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-i="index">
                                    <span class="ng-value-label  text-truncate"> {{ item.name }}</span>
                                    <span class="action-btn-workspace">
                                        <ng-container *ngIf="userSettings$ | async as userSettings">
                                            <span (click)="editWorkspace($event, item)" *ngIf="userSettings.tenant_owner">
                                                <i data-feather="edit-2" [size]="16" class="cursor-pointer"></i>
                                            </span>
                                            <span (click)="editWorkspace($event, item)" *ngIf="!userSettings.tenant_owner && item.default === false">
                                                <i data-feather="eye" [size]="16" class="cursor-pointer"></i>
                                            </span>
                                        </ng-container>
                                    </span>
                                </ng-template>
                            </ng-select>
                        </div>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="profileDropdownSignature-Container d-flex flex-column w-100">
                        <div class="SignatureInnerCont d-flex justify-content-center align-items-center my-1">
                            <h3 class="font-small-3 text-muted" *ngIf="!(userSettings$ | async)?.signature">
                                {{t("Dropdown menu text (Navbar section) - Signature here")}}</h3>
                            <img *ngIf="(userSettings$ | async)?.signature" class="navbar-header-signature-img"
                                [attr.src]="sessionImageService.getSignatureImages()" alt="Signature" />
                        </div>
                        <p class="cursor-pointer font-small-2 d-flex text-primary justify-content-end align-items-center me-1 mb-0"
                            [routerLink]="['/profile-settings']" [queryParams]="{a: 'signature'}">{{t("Dropdown menu
                            text (Navbar section) - Change your signature")}}</p>
                    </div>

                    @if ((canViewUsersTab$ | async) || (canViewGroupsTab$ | async) || (canViewRolesTab$ | async)) {
                    <div class="dropdown-divider"></div>
                    }
                    @if ((canViewUsersTab$ | async)) {
                    <a ngbDropdownItem [routerLink]="['/users']"><span [data-feather]="'users'"
                            [class]="'me-50'"></span> {{t("Dropdown menu text (Navbar section) - User")}}</a>
                    }

                    @if ((canViewGroupsTab$ | async) || (canViewRolesTab$ | async)) {
                    <a ngbDropdownItem [routerLink]="['/users/groups-and-roles']"><span [data-feather]="'users'"
                            [class]="'me-50'"></span> {{((canViewGroupsTab$ | async) && (canViewRolesTab$ | async)) ?
                        t("Dropdown menu text (Navbar section) - Roles and groups") : (canViewRolesTab$ | async) ?
                        t("Role tab name (user page) - Roles") : t("Group tab name (user page) - Groups")}}</a>
                    }

                    <a ngbDropdownItem class="hidden" (click)="modalOpenBillingModal(billingModal)"><span
                            [data-feather]="'credit-card'" [class]="'me-50'"></span> {{t("Dropdown menu text (Navbar
                        section) - Billing")}}</a>

                    <div class="dropdown-divider"></div>

                    <!-- <a ngbDropdownItem ><span [data-feather]="'edit-3'" [class]="'me-50'"></span>Signature left <span class="float-end font-small-2 mt-25 text-muted">20</span></a>
      
      <a ngbDropdownItem ><span [data-feather]="'mail'" [class]="'me-50'"></span> SMS available <span class="float-end font-small-2 mt-25 text-muted">20</span></a>
      
      <div class="dropdown-divider"></div> -->

                    <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'"
                            [class]="'me-50'"></span>{{t("Dropdown menu text (Navbar section) - Logout")}}</a>
                </div>
            </li>
            <!--/ User Dropdown -->
        </ul>
    </div>

    <!-- Billing Overview Modal Html -->
    <ng-template #billingModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">Billing overview</h4>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="modal-body-wrapper">
                <div class="row billing-row-head">
                    <div class="billing-plan">
                        <div class="text-area-top">
                            <span>Current plan <strong>Free</strong></span>
                        </div>
                        <div class="text-area-middle"><span class="bigger-text">22/30</span> <span>Users</span></div>
                        <div class="button-area">
                            <button type="button" class="btn btn-outline-primary" rippleEffect>Manage Users</button>
                        </div>
                    </div>

                    <div class="billing-plan justify-content-center">
                        <div class="text-area-top"><span>Free Account</span></div>
                    </div>

                    <div class="billing-plan">
                        <div class="text-area-top"><span>Your credits</span></div>
                        <div class="text-area-middle"><span class="bigger-text">269.5</span> <span>Signatures</span>
                            <span class="bigger-text">47</span> <span>SMS</span>
                        </div>
                        <div class="button-area">
                            <button type="button" class="btn btn-outline-primary" rippleEffect>Add Signatures</button>
                            <button type="button" class="btn btn-outline-primary" rippleEffect>Add SMS</button>
                        </div>
                    </div>
                </div>

                <div class="row billing-row-head mt-1">
                    <div class="billing-plan billing-plan-half invoice-box">
                        <div class="invoice-row-top">
                            <h6>Paid invoice<span class="invoice-number">#5414</span></h6>
                        </div>

                        <div class="invoice-row-middle">
                            <p><span>Amount</span> <span>€1</span></p>
                            <p><span>Billing date</span> <span>15-10-2022 5:00AM</span></p>
                        </div>

                        <div class="invoice-row-bottom">
                            <span class="show-all-invoice">See all invoices</span>
                        </div>
                    </div>

                    <div class="billing-plan billing-plan-half addons-included">
                        <div class="addons-included-row-top">
                            <h6>Addons included in your plan</h6>

                            <div class="addons-include-table">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Price per month</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="no-record">
                                                <td colspan="3">
                                                    No documents
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="addons-included-row-bottom">
                            <span class="manage-add-ons">Manage add ons</span>
                        </div>
                    </div>
                </div>

                <div class="row billing-row-head mt-1 px-2">
                    <p>
                        Need to cancel your subscription? We know circumstance can sometimes change. But before you go,
                        have you tried: <a>Our support center</a> for technical FAQs <strong>No, I'm sure I want to
                        </strong>
                        <a>Cancel my subscription</a>
                    </p>
                </div>
            </div>
        </div>
        <!-- <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>
      Save
      </button>
  </div> -->
    </ng-template>
    <!-- / Billing Overview Modal Html -->

</ng-container>